export function isPersonalAdminRequest(url: string, api: string, origin: string, uploadApi?: string) {
    const base = new URL(api, origin);
    const request = new URL(url, origin);
    const prefix = base.pathname.replace(/\/$/, '');
    if (uploadApi) {
        const upload = new URL(uploadApi, origin);
        const uploadPrefix = upload.pathname.replace(/\/$/, '');
        if (request.origin === upload.origin && request.pathname.startsWith(uploadPrefix + '/chunked-upload/')) return true;
    }
    if (request.origin !== base.origin || !request.pathname.startsWith(prefix + '/')) return false;
    return /^\/(personal|demos|highlights|game-server|faceit|steam|raffles|scout|demo-shares|chunked-upload|stratsync-lineups|maintenance)(?:\/|$)/.test(request.pathname.slice(prefix.length));
}
